import { combineReducers } from "redux";
import appReducer from "./app.reducer";
import loginReducer from "./login.reducer";
import authReducer from "./auth.reducer";
import meetingReducer from "./meeting.reducer";
import buildingsReducer from "./other_info/building.reducer";
import locationsReducer from "./other_info/location.reducer";
import roomsReducer from "./other_info/room.reducer";
import positionsReducer from "./other_info/position.reducer";
import departmentReducer from "./other_info/department.reducer";
import titlesReducer from "./other_info/title.reducer";
import userReducer from "./user.reducer";
import positionsMeetingReducer from "./other_info/position_meeting.reducer";
import groupNamesReducer from "./other_info/group_name.reducer";
import groupItemsReducer from "./other_info/group_item.reducer";

export default combineReducers({
  appReducer,
  loginReducer,
  authReducer,
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,
  positionsReducer,
  departmentReducer,
  titlesReducer,
  userReducer,
  positionsMeetingReducer,
  groupNamesReducer,
  groupItemsReducer,
});
